<template>
  <div>
    <a-switch-field
      :varName="getVarNameRequired"
      :varLabel="getVarLabelRequired"
      :varRequired="true"
      :varInitial="getVarInitialRequired"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-switch-field
      :varName="getVarNameEnabled"
      :varLabel="getVarLabelEnabled"
      :varRequired="true"
      :varInitial="getVarInitialEnabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  components: {

  },
  computed: {
      getVarLabelEnabled() {
          return `${this.varVerbose} Enabled`;
      },
      getVarNameEnabled() {
          return `registration_options.fields.${this.varName}.enabled`;
      },
      getVarInitialEnabled() {
          return this.data.registration_options.fields[this.varName].enabled;
      },
      getVarLabelRequired() {
          return `${this.varVerbose} Required`;
      },
      getVarNameRequired() {
          return `registration_options.fields.${this.varName}.required`;
      },
      getVarInitialRequired() {
          return this.data.registration_options.fields[this.varName].required;
      }
  },
  props: {
    formLayout: String,
    size: String,
    data: Object,
    varName: String,
    varVerbose: String
  }
};
</script>